<template>
	<div class="tw-w-full">
		<div
			class="tw-text-xl tw-font-semibold tw-py-4"
			v-html="t('rc.message_confirm_change')"></div>
		<ul class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-list-none tw-w-full tw-py-4 tw-px-8">
			<li
				v-for="(item, idx) in history"
				class="tw-w-full tw-text-base tw-py-2 tw-px-4 tw-flex tw-flex-row tw-items-center tw-justify-between"
				:class="[idx % 2 === 0 ? 'tw-bg-primary-50' : 'tw-bg-primary-100']"
				:key="item.name">
				<span>{{ item.name }}:</span>
				<span class="tw-font-bold">
					<span
						class="tw-text-gray-500"
						v-html="t('rc.label_old_value')"></span>
					:
					{{ item.oldValue }}{{ item.unit }}
					→
					<span
						class="tw-text-gray-500"
						v-html="t('rc.label_new_value')"></span>
					:
					{{ item.value }}{{ item.unit }}
					<button
						v-if="findStatus(item.index, item.subIndex) === 'OK'"
						class="tw-bg-status-green-500">
						<FontAwesomeIcon icon="check" />
					</button>
					<button
						v-else
						:class="['tw-ml-2', idx % 2 === 0 ? 'tw-bg-primary-50' : 'tw-bg-primary-100', 'hover:tw-animate-pulse']"
						@click="$emit('deleteHistory', item.index + '_' + item.subIndex)">
						<FontAwesomeIcon icon="trash" />
					</button>
					<div
						v-if="findStatus(item.index, item.subIndex) !== 'OK'"
						class="tw-text-status-red-500 tw-text-xs tw-font-semibold">
						{{ findStatus(item.index, item.subIndex) }}
					</div>
				</span>
			</li>
		</ul>
	</div>
</template>
<script setup lang="ts">
import type {PropType} from "vue";
import type {RCHistoryValue} from "./RemoteControlForm.vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import { useTranslation } from "i18next-vue";

const { t } = useTranslation();

const findStatus = (index: number, subIndex: number) => {
	if (Object.keys(props.status).find((i) => i === props.deviceId + "_" + index + "_" + subIndex)) {
		return props.status[props.deviceId + "_" + index + "_" + subIndex];
	}
};

defineEmits(["deleteHistory"]);
const props = defineProps({
	history: {
		type: Array as PropType<RCHistoryValue[]>,
		required: true,
	},
	status: {
		type: Object as PropType<Record<string, "OK" | string>>,
		required: true,
	},
	deviceId: {
		type: Number,
		required: true,
	},
});
</script>